import ArticleBookmark from '@/article_bookmark'
import TooltipsHandler from '@/tooltips_handler'
import * as Stickyfill from 'stickyfilljs'

document.addEventListener('DOMContentLoaded', () => {
  const csrfToken: string = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute('content')

  const articleBookmark = new ArticleBookmark(csrfToken)

  document.querySelectorAll('.js-article-bookmark').forEach(bookmarkArea => {
    const articleId: number = parseInt(
      (bookmarkArea as HTMLElement).dataset.articleId,
      10
    )

    const turnOnbutton = bookmarkArea.querySelector('.js-turn-on .js-button')
    turnOnbutton.addEventListener('click', () => {
      articleBookmark
        .bookmark(articleId)
        .then(response => {
          response.status === 'OK' ? turnOn() : onError(response.errors)
        })
        .catch(() => {
          onError()
        })
    })

    const turnOffButton = bookmarkArea.querySelector('.js-turn-off .js-button')
    // 非ログイン状態の時のみボタン自体がHTML常に存在しないため return してます。
    if (!turnOffButton) {
      return
    }
    turnOffButton.addEventListener('click', () => {
      articleBookmark
        .unbookmark(articleId)
        .then(response => {
          response.status === 'OK' ? turnOff() : onError(response.errors)
        })
        .catch(() => {
          onError()
        })
    })
  })

  const stickyAreas: NodeListOf<HTMLElement> = document.querySelectorAll(
    '.sticky-areas'
  )
  Stickyfill.add(stickyAreas)

  // FIXME: サイトトップでも同じロジック使ってるのでモジュール化して import したいところ
  const tabs: NodeListOf<HTMLElement> = document.querySelectorAll(
    '.js-access-rankings .js-ranking-tab'
  )
  const tabpanels: NodeListOf<HTMLElement> = document.querySelectorAll(
    '.js-access-rankings .js-ranking-tabpanel'
  )
  tabs.forEach(rankingTab => {
    rankingTab.addEventListener('click', event => {
      const target = event.target as HTMLElement
      tabs.forEach(tab => {
        tab === target
          ? tab.classList.add('active')
          : tab.classList.remove('active')
      })
      const targetTabpanelName = target.dataset.targetTabpanelName
      tabpanels.forEach(tabpanel => {
        tabpanel.dataset.tabpanelName === targetTabpanelName
          ? tabpanel.classList.add('active')
          : tabpanel.classList.remove('active')
      })
    })
  })

  // 用語ツールチップの出現制御
  {
    const tooltip = new TooltipsHandler(document.querySelector('.main-content'))
    // iOS だと window, document, body で click イベントを拾わないという仕様があるため、
    // touchend イベントが使える場合は touchend を listen してる。
    // CSS で cursor: pointer; を付与すれば click イベント拾うようになるけど、
    // pointer メディアクエリ使うにしても大胆すぎるからやめておいた。
    const listenEvent = window.ontouchend === undefined ? 'click' : 'touchend'
    let touchmoved = false
    document.body.addEventListener('touchmove', () => (touchmoved = true))
    document.querySelectorAll('.word-link').forEach(element => {
      element.addEventListener(listenEvent, event => {
        touchmoved ? (touchmoved = false) : tooltip.handle(event)
      })
    })
    document.body.addEventListener(listenEvent, () => {
      touchmoved ? (touchmoved = false) : tooltip.removeAll()
    })
  }
})

const turnOn = () => {
  document.querySelectorAll('.js-article-bookmark').forEach(bookmarkArea => {
    const classList = bookmarkArea.classList
    classList.add('js-article-bookmark-on')
    classList.remove('js-article-bookmark-off')
  })
}

const turnOff = () => {
  document.querySelectorAll('.js-article-bookmark').forEach(bookmarkArea => {
    const classList = bookmarkArea.classList
    classList.add('js-article-bookmark-off')
    classList.remove('js-article-bookmark-add')
  })
}

const onError = (errors?: string[]) => {
  const message: string =
    0 < errors.length
      ? errors.join('\n')
      : '更新に失敗しました。ページを再読み込みしてからもう一度お試しください'

  alert(message)
}
